const Title = ({ children }) => (
  <div className="font-medium text-xl mb-2">{children}</div>
);

export default Title;
